import { Col, Modal, Row } from "antd";
import React, { useRef } from "react";
import { useDispatch } from "react-redux";

import "../../../../assets/style/modalStyle/addAccount.scss";

import { useState } from "react";
import {} from "../../../../services/slice/StoreSlice";
import TranslateText from "../../TranslateText";
import BaseButton from "../../Button/BaseButton";
import LabelInput from "../../LabelInput";
import InputText from "../../Input/InputText";
import { IconUpLoad } from "../../../../assets/icon";
import SelectValue from "../../Selector/SelectValue";
import { addFileSpam } from "../../../../services/slice/SpamSlice";

const ModalAddSpamFile = ({ open, width, setOpen = () => {} }) => {
  const inputRef = useRef();
  const [dataAdd, setDataAdd] = useState({
    name: "",
    file: "",
    typeFileData: 1,
  });

  const dispatch = useDispatch();
  const handleCancel = () => {
    setOpen(false);
  };
  const valueOptionsRole = [
    {
      value: 0,
      label: "brand_name",
    },

    {
      value: 1,
      label: "data_spam_android",
    },
    {
      value: 2,
      label: "data_spam_iOS",
    },
  ];
  const handleSave = () => {
    const dataForm = new FormData();
    dataForm.append("file", dataAdd.file);
    dataForm.append("typeFileData", dataAdd.typeFileData);
    dispatch(addFileSpam(dataForm));
    setOpen(false);
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0]; // Lấy file đầu tiên trong danh sách

    if (file) {
      // Đọc dữ liệu file
      setDataAdd({
        ...dataAdd,
        name: file.name,
        file: file,
      });
      const reader = new FileReader();
      reader.onload = (event) => {};
      reader.readAsDataURL(file); // Có thể đổi sang readAsText(file) nếu là file text
    }
  };
  return (
    <>
      <Modal
        maskClosable={false}
        title={<TranslateText text={"Thêm mới file data  spam"} />}
        centered
        open={open}
        className="warrperModalAddAcc"
        width={width}
        footer={[
          <div className="evenSpace">
            <BaseButton
              content={"Hủy bỏ"}
              typeBtn="btnCancel"
              width={155}
              handleClick={handleCancel}
            />
            <BaseButton
              isEnter={true}
              width={155}
              content={"Đồng ý"}
              typeBtn=" btnOrange"
              handleClick={handleSave}
            />
          </div>,
        ]}
        onCancel={handleCancel}
      >
        <Row align={"middle"} style={{ marginBottom: "3rem" }}>
          <Col span={6}>
            <LabelInput text={"Loại file"} />
          </Col>
          <Col span={16}>
            <SelectValue
              type={"selectGray base"}
              optionsValue={valueOptionsRole}
              width={420}
              defaultValue={"brand_name"}
              handleChange={(value) => {
                setDataAdd({
                  ...dataAdd,
                  typeFileData: value,
                });
              }}
              key="selectFileSpam"
            />
          </Col>
        </Row>
        <Row align={"middle"}>
          <Col span={6}>
            <LabelInput text={"File spam"} />
          </Col>
          <Col span={16}>
            <InputText
              readOnly={true}
              text={dataAdd.name}
              typeInput={"baseInput"}
              placeholder={"Tên file spam"}
              suffix={<IconUpLoad fill="rgba(0, 0, 0, 0.4)" />}
              onClick={() => inputRef.current.click()}
            />
            <input
              type="file"
              onChange={handleFileChange}
              style={{ display: "none" }}
              ref={inputRef}
            />
          </Col>
        </Row>
      </Modal>
    </>
  );
};

export default ModalAddSpamFile;
